import React from 'react';

const ModuleTile = ({ module, currentProject }) => {
  const getModuleUrl = (module, projectKey) => {
    if (module.base_url) {
      return `${module.base_url}?projectKey=${projectKey}`;
    }

    // Fallback URLs based on slug
    const fallbackUrls = {
      'data-collection': process.env.DEFAULT_DATA_COLLECTION_URL || 'https://collect.gyso.au',
      'identity': process.env.DEFAULT_IDENTITY_URL || 'https://identity.gyso.au',
      'logo-builder': process.env.DEFAULT_LOGO_BUILDER_URL || 'https://logo.gyso.au',
    };

    const baseUrl = fallbackUrls[module.slug];
    return baseUrl ? `${baseUrl}?projectKey=${projectKey}` : '#';
  };

  const handleLaunch = () => {
    if (currentProject && module.status === 'active') {
      const url = getModuleUrl(module, currentProject.project_key);
      window.open(url, '_blank');
    }
  };

  const isDisabled = !currentProject || module.status !== 'active';

  const getButtonText = () => {
    if (module.status === 'coming_soon') return 'Coming Soon';
    if (!currentProject) return 'Select a project first';
    return 'Open';
  };

  const getStatusColor = () => {
    switch (module.status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'coming_soon':
        return 'bg-gray-100 text-gray-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="text-2xl mb-2">
          {module.icon_emoji || '📱'}
        </div>
        <div className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor()}`}>
          {module.status === 'active' ? 'Active' : 'Coming Soon'}
        </div>
      </div>

      <h3 className="font-semibold text-slate-900 mb-2">
        {module.display_name}
      </h3>

      <p className="text-sm text-slate-600 mb-4 line-clamp-2">
        {module.description}
      </p>

      <button
        onClick={handleLaunch}
        disabled={isDisabled}
        className={`w-full py-2 px-4 rounded-lg font-medium text-sm transition-colors ${
          isDisabled
            ? 'bg-slate-100 text-slate-500 cursor-not-allowed'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        {getButtonText()}
      </button>
    </div>
  );
};

export default ModuleTile;